// LocalStorage keys for persistent state
export const STORAGE_KEYS = {
  AUDIO_STATE: 'soyo-audio-state',
  EPISODE_POSITIONS: 'soyo-episode-positions',
  THEME_PREFERENCE: 'soyo-theme-preference',
  AUTO_SCROLL_ENABLED: 'soyo-auto-scroll-enabled'
};
